type Freeze = (timeout?: number) => Promise<number>

export const freeze: Freeze = (timeout = 1000) =>
  new Promise(resolve => setTimeout(resolve, timeout))
